import type { RouteRecordRaw } from "vue-router"

/**
 * 门店统一预订工作台：单店与连锁共用入口，数据按服务端组织权限隔离。
 *
 * 权限:business_booking；预订路由直接承载 Smart 工作台，确保 URL 与侧栏选中项同源。
 */
const Layout = () => import("@/layout/index.vue")
const ReservationWorkbench = () => import("@/views/page/business/index.vue")
const ReservationContent = () => import("@/views/page/setting/components/ProductByPhone/ShopOrder.vue")

const RESERVATION_PERMISSIONS = ["business_booking"]
const RESERVATION_CONTENT_PERMISSIONS = ["setting_shop_order"]
const isReservationWorkbenchFeatureEnabled = import.meta.env.VITE_RESERVATION_WORKBENCH_FEATURE_ENABLED !== "false"

const firstReservationLevelRoute: RouteRecordRaw[] = [
  {
    path: "/reservation/workbench/index",
    name: "ReservationWorkbench",
    component: ReservationWorkbench,
    meta: {
      activeMenu: "/reservation/workbench/index",
      title: "预订",
      svgIcon: "nav-reservation",
      permissions: RESERVATION_PERMISSIONS,
    },
  },
  {
    path: "/reservation/workbench",
    redirect: "/reservation/workbench/index",
    meta: { hidden: true, permissions: RESERVATION_PERMISSIONS },
  },
  {
    path: "/reservation/content",
    redirect: "/reservation/content/index",
    meta: {
      activeMenu: "/reservation/workbench/index",
      title: "包间资料",
      hidden: true,
      permissions: RESERVATION_CONTENT_PERMISSIONS,
    },
    children: [
      {
        path: "/reservation/content/index",
        name: "ReservationContent",
        component: ReservationContent,
        props: { contentOnly: true },
        meta: {
          activeMenu: "/reservation/workbench/index",
          title: "包间资料",
          hidden: true,
          permissions: RESERVATION_CONTENT_PERMISSIONS,
        },
      },
    ],
  },
]

export const createReservationRoutes = (): RouteRecordRaw[] => [
  {
    path: "/reservation",
    component: Layout,
    redirect: "/reservation/workbench/index",
    children: firstReservationLevelRoute,
    meta: {
      order: 1.5,
      title: "预订",
      showTag: false,
      svgIcon: "nav-reservation",
      permissions: RESERVATION_PERMISSIONS,
      scopeTypes: ["shop", "chain-store"],
    },
  },
]

const reservation: RouteRecordRaw[] = isReservationWorkbenchFeatureEnabled ? createReservationRoutes() : []
export default reservation
